
import './App.css';
import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
// import Accountants from './Pages/Accountants/index.jsx';
// import Home from './pages/Home/index.jsx';
import Navbar from './components/navbar/index.jsx';
import Footer from './components/Footer/Footer.js';
import MainPage from './pages/MainPage/MainBody.js';
import RaiseFunding from './pages/RaiseFunding/RaiseFunding.js';
import Blog from './pages/Blog/Blog.js';
import Unlisted from './pages/Unlisted/index.jsx';
import Drhp from './pages/Drhp/index.jsx';
import Screener from './pages/Screener/index.jsx';
import SellIPOShares from './pages/SellIPOShares/SellIPOShares.js';
import MediaCoverage from './pages/MediaCoverage/MediaCoverage.js';
import ContactUs from './pages/ContactUs/Contact.js';
import Polymatech from './pages/Polymatech/Polymatech.js';
import KnowledgeCenter from './pages/KnowledgeCenter/KnowledgeCenter.js';
import Offmarket from './pages/Offmarket/index.js';
import Sebi from './pages/Sebi/index.js';
import Frequently from './pages/Frequently/index.js';
import CardViewMore from './pages/MainPage/MainPageContent/CardViewMore.js';
import Disclaimer from './pages/Disclaimer/Disclaimer.js';
import Sebiguiude from './pages/Sebiguide/Sebiguide.js';
import Terms from './pages/TermsOfUse/Terms.js';
import Privacy from './pages/Privacy/Privacy.js';
import BankingAlert from './pages/BankingAlert/BankingAlert.js';
import TopSectors from './pages/TopSectors/TopSectors.js';
import AboutUs from './pages/AboutUs/AboutUs.jsx';
import SignUp from './pages/SignUp/SignUp.js';
import SignIn from './pages/SignUp/SignIn.js';
import UnlistShareCard from './pages/UnlistShareCard/UnlistShareCard.js';
import { useState } from 'react';
import { imageApi } from "./components/Api/Api.jsx"
import FundRaise from "./pages/NewPages/FundRaise.js";
import SMELoans from "./pages/NewPages/SMELoans.js";
import BuySell from "./pages/NewPages/BuySell.js";
import PEInvestor from './pages/NewPages/PEInvestor.js';
import StartUp from "./pages/PEInvestorPage/StartUp.js";
import Business from "./pages/PEInvestorPage/Business.js";
import EarlyBusiness from "./pages/PEInvestorPage/EarlyBusiness.js";
import Debentures from "./pages/PEInvestorPage/Debentures.js";
import ProjectInvestment from './pages/PEInvestorPage/ProjectInvestment.js';
import Shark from './pages/shark/Shark.jsx';
import SharkForm from './pages/shark/SharkForm.jsx';
import ThankYou from './pages/shark/ThankYou.jsx';
import NewBlogs from './pages/newblogs/NewBlogs.jsx';
import BlogDetails from './pages/newblogs/BlogDetails.jsx';
import { Home } from '@mui/icons-material';
// import Media from './pages/Media/index.jsx'; 

function App() {
  const [head, setHead] = useState("")
  const [ids, setIds] = useState("")
  const [imgs, setImgs] = useState("")

  return (
    <>
      {/* <RouterProvider router={router}/> */}

      <Router>
        

        <Routes>
          {/* <Route path="/" element={<Navigate replace to="/home" />} /> */}
          <Route path={'/'} exact element={<MainPage headings={setHead} idpoly={setIds} images={setImgs} />} />
          <Route path={'/raisefunding'} exact element={<RaiseFunding />} />
          <Route path={'/fundraise'} exact element={<FundRaise />} />
          <Route path={'/smeloans'} exact element={<SMELoans />} />
          <Route path={'/buysell'} exact element={<BuySell />} />
          <Route path={'/peinvestor'} exact element={<PEInvestor />} />
          <Route path={'/about'} exact element={<AboutUs />} />
          <Route path={'/business-opportunities'} exact element={<SellIPOShares />} />
          <Route path={'/limited-partnerships'} exact element={<Unlisted headings={setHead} idpoly={setIds} images={setImgs} />} />
          {/* <Route path={'/drhp'} exact element={<Drhp />} /> */}
          {/* <Route path={'/screener'} exact element={<Screener />} /> */}
          <Route path={'/insights'} exact element={<MediaCoverage />} />
          <Route path={'/contactus'} exact element={<ContactUs />} />
          <Route path={'/company'} exact element={<Polymatech heading={head} id={ids} img={imgs} />} />
          <Route path={'/blog'} exact element={<Blog />} />
          <Route path={'/knowledgecenter'} exact element={<KnowledgeCenter />} />
          <Route path={'/off-market'} exact element={<Offmarket />} />
          {/* <Route path={'/sebi'} exact element={<Sebi />} /> */}
          <Route path={'/frequently-asked-questions'} exact element={<Frequently />} />
          <Route path={'/companylist'} exact element={<CardViewMore headings={setHead} idpoly={setIds} />} />
          <Route path={'/disclaimer'} exact element={<Disclaimer />} />
          <Route path={'/sebiguidelines'} exact element={<Sebiguiude />} />
          <Route path={'/terms'} exact element={<Terms />} />
          <Route path={'/privacy'} exact element={<Privacy />} />
          <Route path={'/banking'} exact element={<BankingAlert />} />
          <Route path={'/topsectors'} exact element={<TopSectors />} />
          {/* <Route path={'/signup'} exact element={<SignUp />} /> */}
          {/* <Route path={'/signin'} exact element={<SignIn />} /> */}
          <Route path={'/unlistsharecard'} exact element={<UnlistShareCard />} />
          <Route path={'/startUp'} exact element={<StartUp />} />
          <Route path={'/business'} exact element={<Business />} />
          <Route path={'/earlyBusiness'} exact element={<EarlyBusiness />} />
          <Route path={'/debentures'} exact element={<Debentures />} />
          <Route path={'/projectInvestment'} exact element={<ProjectInvestment />} />
          <Route path={'/be-a-shark'} exact element={<Shark />} />
          <Route path={'/be-a-shark-form'} exact element={<SharkForm />} />
          <Route path={'/thank-you'} exact element={<ThankYou />} />
          <Route path={'/blogs'} exact element={<NewBlogs />} />
          <Route path={'/blog-detail/:id'} exact element={<BlogDetails />} />

          {/* <Route path={'/signin'} exact element={<Signin />}/>
        <Route path={'/signup'} exact element={<Signup />}/>
        <Route path={'/forgot'} exact element={<Forgot />}/>
        <Route path={'/reset_password'} exact element={<Resetting />}/>
        <Route path={'/settings'} exact element={<Settings />}/>
        <Route path={'/features'} exact element={<Features />}/>
        <Route path={'/defi'} exact element={<Defi />}/>
        <Route path={'/pow'} exact element={<Pow />}/>
        <Route path={'/passive'} exact element={<Passive/>}/>
         <Route path={'/signupp'} exact element={<Signupp  />}/>

        <Route path={'/nft'} exact element={<Nft/>}/>
        <Route path={'/airdrop'} exact element={< Airdrop />}/>
        <Route path={'/about'} exact element={<About/>}/>
         <Route path={'/checkout'} exact element={<Checkout/>}/> 
        <Route path={'/integration'} exact element={<Integration />}/>
        <Route path={'/accountants'} exact element={<Accountants />}/>
        <Route path={'/price'} exact element={<Pricing />}/>
        <Route path={'/blogs'} exact element={<Resources />}/>
        <Route path={'/privacy-policy'} exact element={<Privacy />}/>
        <Route path={'/terms'} exact element={<Terms />}/>
        <Route path={'/dashboard'} exact element={<Dashboard />}/>
        <Route path={'/imports'} exact element={<Import />}/>
        <Route path={'/transactions'} exact element={<Transactions />}/>
        <Route path={'/reports'} exact element={<Reports />}/> */}
        </Routes>
      </Router>
    </>
  );
}

export default App;
